import { useState } from "react";
import { ChevronLeft, ChevronRight, Sparkles } from "lucide-react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Eyebrow from "@/components/common/Eyebrow";
import { TESTIMONIALS } from "@/constants/homeContent";

export default function TestimonialCarousel() {
  const [index, setIndex] = useState(0);
  const t = TESTIMONIALS[index];
  const prev = () => setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setIndex((i) => (i + 1) % TESTIMONIALS.length);

  return (
    <Box component="section" sx={{ pt: { xs: 8, md: 10 } }} data-testid="testimonials-section">
      <Box sx={{ maxWidth: 1400, mx: "auto", px: { xs: 3, lg: 6 }, display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, gap: { xs: 3, md: 6 }, alignItems: "start" }}>
        <Box>
          <Eyebrow sx={{ mb: 1.5, display: "flex", alignItems: "center" }}>
            <Sparkles size={11} style={{ display: "inline", marginRight: 8 }} />Voices
          </Eyebrow>
          <Typography component="h2" className="font-serif-display" sx={{ fontSize: { xs: 28, md: 34 } }}>
            Travellers who linger longer.
          </Typography>
        </Box>
        <Box>
          <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1.5, mb: 2 }}>
            <IconButton onClick={prev} data-testid="testimonial-prev" size="small" sx={{ border: 1, borderColor: "divider" }}>
              <ChevronLeft size={15} />
            </IconButton>
            <IconButton onClick={next} data-testid="testimonial-next" size="small" sx={{ border: 1, borderColor: "divider" }}>
              <ChevronRight size={15} />
            </IconButton>
            <Typography variant="caption" color="text.secondary">{index + 1} / {TESTIMONIALS.length}</Typography>
          </Box>
          <Typography className="font-serif-display" sx={{ fontSize: { xs: 17, md: 19 }, lineHeight: 1.55, mb: 2.5 }} data-testid="testimonial-quote">
            "{t.quote}"
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box component="img" src={t.img} alt={t.name} sx={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover" }} />
            <Box>
              <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{t.name}</Typography>
              <Typography sx={{ fontSize: 12, color: "text.secondary" }}>{t.location}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
